import script from "./LangSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./LangSelector.vue?vue&type=script&setup=true&lang=js"

import "./LangSelector.vue?vue&type=style&index=0&id=34f94d9c&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34f94d9c"]])

export default __exports__